// Import everything from autoload folder
import './autoload/ada-compliance.js'; import './autoload/foundation.js'; import './autoload/lazyload.js'; // eslint-disable-line

// Import local dependencies
import './plugins/modernizr.min';
import './plugins/jquery.parallax-scroll';
import 'slick-carousel';
import 'jquery-match-height';
import objectFitImages from 'object-fit-images';
// import '@fancyapps/fancybox/dist/jquery.fancybox.min';
import { jarallax, jarallaxElement } from 'jarallax';
import ScrollOut from 'scroll-out';

/**
 * Init foundation
 */
$(document).foundation();

function msieversion() {
  var ua = window.navigator.userAgent;
  var msie = ua.indexOf('MSIE ');

  if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv:11\./)) {
    // If Internet Explorer, return version number
    $('.section-background').removeClass('jarallax');
    $('.section-background').addClass('section-background--ie');
  } // If another browser, return 0

  return false;
}

// When section shown in a viewport
function isInViewport(node) {
  let rect = node.getBoundingClientRect();
  return (
    (rect.height > 0 || rect.width > 0) &&
    rect.bottom >= 0 &&
    rect.right >= 0 &&
    rect.top <= (window.innerHeight || document.documentElement.clientHeight) &&
    rect.left <= (window.innerWidth || document.documentElement.clientWidth)
  );
}

/*
 *  This function will render a Google Map onto the selected jQuery element
 */

function render_map($el) {
  // var
  var $markers = $el.find('.marker');
  var styles = [
    {
      featureType: 'all',
      elementType: 'all',
      stylers: [
        {
          color: '#d5d1d1',
        },
        {
          visibility: 'simplified',
        },
      ],
    },
    {
      featureType: 'all',
      elementType: 'geometry',
      stylers: [
        {
          color: '#d5d1d1',
        },
      ],
    },
    {
      featureType: 'all',
      elementType: 'labels.text.fill',
      stylers: [
        {
          gamma: 0.01,
        },
        {
          lightness: 20,
        },
      ],
    },
    {
      featureType: 'all',
      elementType: 'labels.text.stroke',
      stylers: [
        {
          saturation: -31,
        },
        {
          lightness: '-56',
        },
        {
          weight: '0.74',
        },
        {
          gamma: '0.00',
        },
      ],
    },
    {
      featureType: 'all',
      elementType: 'labels.icon',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'administrative',
      elementType: 'all',
      stylers: [
        {
          color: '#393939',
        },
        {
          visibility: 'simplified',
        },
      ],
    },
    {
      featureType: 'administrative',
      elementType: 'geometry',
      stylers: [
        {
          color: '#d5d1d1',
        },
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'administrative.country',
      elementType: 'geometry',
      stylers: [
        {
          visibility: 'off',
        },
        {
          color: '#d5d1d1',
        },
      ],
    },
    {
      featureType: 'administrative.country',
      elementType: 'labels',
      stylers: [
        {
          visibility: 'simplified',
        },
      ],
    },
    {
      featureType: 'landscape',
      elementType: 'all',
      stylers: [
        {
          color: '#d5d1d1',
        },
      ],
    },
    {
      featureType: 'landscape',
      elementType: 'geometry',
      stylers: [
        {
          color: '#d5d1d1',
        },
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'landscape',
      elementType: 'geometry.fill',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'landscape',
      elementType: 'geometry.stroke',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'landscape',
      elementType: 'labels',
      stylers: [
        {
          visibility: 'simplified',
        },
      ],
    },
    {
      featureType: 'landscape',
      elementType: 'labels.text',
      stylers: [
        {
          color: '#393939',
        },
      ],
    },
    {
      featureType: 'landscape.man_made',
      elementType: 'all',
      stylers: [
        {
          color: '#d5d1d1',
        },
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'landscape.natural',
      elementType: 'all',
      stylers: [
        {
          color: '#d5d1d1',
        },
        {
          visibility: 'simplified',
        },
      ],
    },
    {
      featureType: 'landscape.natural.landcover',
      elementType: 'all',
      stylers: [
        {
          color: '#d5d1d1',
        },
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'landscape.natural.landcover',
      elementType: 'geometry',
      stylers: [
        {
          visibility: 'off',
        },
        {
          color: '#d5d1d1',
        },
        {
          saturation: '-100',
        },
      ],
    },
    {
      featureType: 'landscape.natural.landcover',
      elementType: 'geometry.fill',
      stylers: [
        {
          saturation: '-100',
        },
        {
          color: '#d5d1d1',
        },
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'landscape.natural.terrain',
      elementType: 'all',
      stylers: [
        {
          visibility: 'off',
        },
        {
          color: '#d5d1d1',
        },
      ],
    },
    {
      featureType: 'poi',
      elementType: 'all',
      stylers: [
        {
          visibility: 'off',
        },
        {
          color: '#cccccc',
        },
        {
          saturation: '-100',
        },
        {
          lightness: '94',
        },
        {
          gamma: '0.00',
        },
      ],
    },
    {
      featureType: 'poi',
      elementType: 'geometry',
      stylers: [
        {
          saturation: 20,
        },
      ],
    },
    {
      featureType: 'poi',
      elementType: 'labels.text',
      stylers: [
        {
          weight: '4.13',
        },
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'poi.park',
      elementType: 'geometry',
      stylers: [
        {
          lightness: 20,
        },
        {
          saturation: -20,
        },
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'road',
      elementType: 'all',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'road',
      elementType: 'geometry',
      stylers: [
        {
          lightness: 10,
        },
        {
          saturation: -30,
        },
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'road',
      elementType: 'geometry.fill',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'road',
      elementType: 'geometry.stroke',
      stylers: [
        {
          saturation: 25,
        },
        {
          lightness: 25,
        },
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'road',
      elementType: 'labels',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'road',
      elementType: 'labels.text',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'road',
      elementType: 'labels.icon',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'water',
      elementType: 'all',
      stylers: [
        {
          lightness: -20,
        },
        {
          color: '#ffffff',
        },
      ],
    },
    {
      featureType: 'water',
      elementType: 'labels',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
  ]; // Uncomment for map styling

  // vars
  var args = {
    zoom: 11,
    // eslint-disable-next-line no-undef
    center: new google.maps.LatLng(0, 0),
    // eslint-disable-next-line no-undef
    mapTypeId: google.maps.MapTypeId.ROADMAP,
    scrollwheel: false,
    styles: styles, // Uncomment for map styling
  };

  // create map
  // eslint-disable-next-line no-undef
  var map = new google.maps.Map($el[0], args);

  // add a markers reference
  map.markers = [];

  // add markers
  $markers.each(function() {
    add_marker($(this), map);
  });

  // center map
  center_map(map);
}

/*
 *  This function will add a marker to the selected Google Map
 */

var infowindow;

function add_marker($marker, map) {
  // var
  // eslint-disable-next-line no-undef
  var latlng = new google.maps.LatLng(
    $marker.attr('data-lat'),
    $marker.attr('data-lng')
  );

  // create marker
  // eslint-disable-next-line no-undef
  var marker = new google.maps.Marker({
    position: latlng,
    map: map,
    icon: $marker.data('marker-icon'), //uncomment if you use custom marker
  });

  // add to array
  map.markers.push(marker);

  // if marker contains HTML, add it to an infoWindow
  if ($.trim($marker.html())) {
    // create info window
    // eslint-disable-next-line no-undef
    infowindow = new google.maps.InfoWindow();

    // show info window when marker is clicked
    // eslint-disable-next-line no-undef
    google.maps.event.addListener(marker, 'click', function() {
      // Close previously opened infowindow, fill with new content and open it
      infowindow.close();
      infowindow.setContent($marker.html());
      infowindow.open(map, marker);
    });
  }
}

/*
 *  This function will center the map, showing all markers attached to this map
 */

function center_map(map) {
  // vars
  // eslint-disable-next-line no-undef
  var bounds = new google.maps.LatLngBounds();

  // loop through all markers and create bounds
  $.each(map.markers, function(i, marker) {
    // eslint-disable-next-line no-undef
    var latlng = new google.maps.LatLng(
      marker.position.lat(),
      marker.position.lng()
    );
    bounds.extend(latlng);
  });

  // only 1 marker?
  if (map.markers.length == 1) {
    // set center of map
    map.setCenter({
      lat: bounds.getCenter().lat() + 0.05,
      lng: bounds.getCenter().lng() - 0.05,
    });
  } else {
    // fit to bounds
    map.fitBounds(bounds);
  }
}

$(document).bind('gform_post_render', function() {
  jQuery('.gfield')
    .not('.file-upload')
    .each(function() {
      var str;
      var startStr = jQuery(this)
        .find('input, textarea')
        .val();
      if (startStr) {
        jQuery(this)
          .find('label')
          .addClass('is-focus');
        jQuery(this).addClass('gfield-active');
      }
      var gfield = jQuery(this);
      jQuery(this)
        .find('input, textarea, select')
        .on('input', function() {
          var input = jQuery(this);
          str = input.val();
          if (str) {
            gfield.addClass('gfield-active');
            gfield.find('label').addClass('is-focus');
          } else {
            gfield.removeClass('gfield-active');
            gfield.find('label').removeClass('is-focus');
          }
        });
    });
});

/**
 * Prevent Body Scrolling With iOS support
 */
let $html = $('html');
let offset;

function preventBodyScrolling() {
  if (!$html.hasClass('is-menu-open')) {
    offset = $(window).scrollTop();
    $html.data('scroll-offset', offset);
    $html.addClass('is-menu-open');
  } else {
    $html.removeClass('is-menu-open');
    offset = $html.data('scroll-offset');
    $(window).scrollTop(offset);
  }
}

/**
 * Fit slide video background to video holder
 */
function resizeVideo() {
  let $holder = $('.videoHolder');
  $holder.each(function() {
    let $that = $(this);
    let ratio = $that.data('ratio') ? $that.data('ratio') : '16:9';
    let width = parseFloat(ratio.split(':')[0]);
    let height = parseFloat(ratio.split(':')[1]);
    $that.find('.video').each(function() {
      if ($that.width() / width > $that.height() / height) {
        $(this).css({
          width: '100%',
          height: 'auto',
        });
      } else {
        $(this).css({
          width: ($that.height() * width) / height,
          height: '100%',
        });
      }
    });
  });
}

/**
 * Scripts which runs after DOM load
 */
$(document).on('ready', function() {
  /**
   * Make elements equal height
   */
  $('.matchHeight').matchHeight();

  $('.acf-map').each(function() {
    render_map($(this));
  });

  msieversion();

  $('.ginput_container_fileupload input').on('change', function() {
    $(this)
      .parent('.ginput_container_fileupload')
      .children('span')
      .remove();
    let f = this.value.replace(/.*[/\\]/, '');
    $(this)
      .parent()
      .append('<span>' + f + '</span>');
  });

  $('input.button--dark').on('click', function() {
    $('.ginput_container_fileupload span').remove();
  });

  (function($) {
    $.fn.hasScrollBar = function() {
      return this.get(0).scrollHeight > this.height();
    };
  })(jQuery);
  let testimonialContent = $('.testimonials-slider-js').find(
    '.testimonial__content'
  );
  $(testimonialContent).each(function() {
    if ($('.testimonial__content').hasScrollBar()) {
      $(this).addClass('testimonials--scroll');
    }
  });

  // Init Jquery UI select
  // $('select')
  //   .not(
  //     "#billing_state, #shipping_state, #billing_country, #shipping_country, [class*='woocommerce'], #product_cat"
  //   )
  //   .each(function() {
  //     // eslint-disable-next-line no-undef
  //     initJUIselect(this);
  //   });

  /**
   * Animate input label on different context
   */
  $('body')
    .on(
      'focus',
      'input:not([type="radio"]):not([type="checkbox"]), select, textarea',
      function() {
        if ($(this).closest('.ginput_complex').length) {
          $(this)
            .closest('span')
            .find('label')
            .addClass('is-focus');
        } else {
          $(this)
            .closest('.gfield')
            .find('label')
            .addClass('is-focus');
        }
        $(this)
          .closest('.acf-field')
          .find('.acf-label')
          .addClass('is-focus');
        $(this)
          .closest('.form-row, .pmpro_checkout-field')
          .find('label')
          .addClass('is-focus');
      }
    )
    .on(
      'blur change',
      'input:not([type="radio"]):not([type="checkbox"]), select, textarea',
      function() {
        if ($(this).val() === '') {
          if ($(this).closest('.ginput_complex').length) {
            $(this)
              .closest('span')
              .find('label')
              .removeClass('is-focus');
          } else {
            $(this)
              .closest('.gfield')
              .find('label')
              .removeClass('is-focus');
          }
          $(this)
            .closest('.acf-field')
            .find('.acf-label')
            .removeClass('is-focus');
          $(this)
            .closest('.form-row, .pmpro_checkout-field')
            .find('label')
            .removeClass('is-focus');
        } else {
          if ($(this).closest('.ginput_complex').length) {
            $(this)
              .closest('span')
              .find('label')
              .addClass('is-focus');
          } else {
            $(this)
              .closest('.gfield')
              .find('label')
              .addClass('is-focus');
          }
          $(this)
            .closest('.acf-field')
            .find('.acf-label')
            .addClass('is-focus');
          $(this)
            .closest('.form-row, .pmpro_checkout-field')
            .find('label')
            .addClass('is-focus');
        }
      }
    );

  /**
   * IE Object-fit cover polyfill
   */
  if ($('.of-cover').length) {
    objectFitImages('.of-cover');
  }

  /**
   * Anchors
   */
  // let anchor;
  $(document).on('click', '.submenu a', function() {
    $('.submenu li').removeClass('current_page_ancestor');
    $(this)
      .parent()
      .addClass('current_page_ancestor');
  });
  /**
   * Add fancybox to images
   */
  // $('.gallery-item')
  //   .find('a[href$="jpg"], a[href$="png"], a[href$="gif"]')
  //   .attr('rel', 'gallery')
  //   .attr('data-fancybox', 'gallery');
  // $(
  //   '.fancybox, a[rel*="album"], a[href$="jpg"], a[href$="png"], a[href$="gif"]'
  // ).fancybox({
  //   minHeight: 0,
  //   helpers: {
  //     overlay: {
  //       locked: false,
  //     },
  //   },
  // });

  /**
   * Init parallax
   */
  jarallaxElement();
  jarallax(document.querySelectorAll('.jarallax'), {
    speed: 0.4,
  });

  /**
   * Detect element appearance in viewport
   */
  ScrollOut({
    treshold: 0,
    once: true,
    onShown: function(element) {
      if ($(element).is('.ease-order')) {
        $(element)
          .find('.ease-order__item')
          .each(function(i) {
            let $this = $(this);
            $(this).attr('data-scroll', '');
            window.setTimeout(function() {
              $this.attr('data-scroll', 'in');
            }, 300 * i);
          });
      }
    },
  });

  /**
   * Remove placeholder on click
   */
  const removeFieldPlaceholder = () => {
    $('input, textarea').each((i, el) => {
      $(el)
        .data('holder', $(el).attr('placeholder'))
        .on('focusin', () => {
          $(el).attr('placeholder', '');
        })
        .on('focusout', () => {
          $(el).attr('placeholder', $(el).data('holder'));
        });
    });
  };
  $(document).on('click', '.header-notification__close', function() {
    let headerNotification = $('.header-notification');
    headerNotification.slideToggle(200, function() {
      headerNotification.remove();
    });
    setTimeout(function() {
      let headerOffset = $('header').outerHeight();
      $('.top-bar').css('top', headerOffset);
    }, 300);
  });
  $('.headers-slider-js').slick({
    cssEase: 'ease',
    arrows: false,
    dots: false,
    infinite: true,
    speed: 1000,
    autoplay: true,
    autoplaySpeed: 2000,
    slidesToShow: 1,
    slidesToScroll: 1,
    rows: 0, // Prevent generating extra markup
  });
  $('.testimonials-slider-js').slick({
    cssEase: 'ease',
    arrows: true,
    dots: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 2000,
    slidesToShow: 2,
    slidesToScroll: 1,
    rows: 0, // Prevent generating extra markup
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });

  $('.accounts-testimonials-js').slick({
    cssEase: 'ease',
    arrows: true,
    dots: true,
    infinite: true,
    autoplay: false,
    autoplaySpeed: 2000,
    slidesToShow: 2,
    slidesToScroll: 1,
    rows: 0, // Prevent generating extra markup
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });

  $('.footer-logos-js').slick({
    cssEase: 'ease',
    arrows: true,
    dots: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 2000,
    slidesToShow: 9,
    slidesToScroll: 1,
    rows: 0, // Prevent generating extra markup
    responsive: [
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: 6,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 641,
        settings: {
          centerMode: true,
          centerPadding: '90px',
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });

  $(document).on('click', '.button--form', function() {
    $('.header_form--hidden').toggleClass('is-active');
  });

  $(document).on('click', '.header_form__close', function() {
    $('.header_form--hidden').removeClass('is-active');
  });

  removeFieldPlaceholder();
  function inputOnFocus() {
    let inputValue = $('.gform_wrapper').find('input');
    $(inputValue).each(function() {
      if ($(this).val().length !== 0) {
        $(this).addClass('is-focus');
      }
    });
  }

  $(document).on('click', '.gform_button', function() {
    inputOnFocus();
  });

  $(document).on('gform_post_render', () => {
    removeFieldPlaceholder();

    $('.ginput_container_fileupload input').on('change', function() {
      $(this)
        .parent('.ginput_container_fileupload')
        .children('span')
        .remove();
      let f = this.value.replace(/.*[/\\]/, '');
      $(this)
        .parent()
        .append('<span>' + f + '</span>');
    });

    $('input.button--dark').on('click', function() {
      $('.ginput_container_fileupload span').remove();
    });
  });

  /**
   * Scroll to Gravity Form confirmation message after form submit
   */
  $(document).on('gform_confirmation_loaded', function(event, formId) {
    let $target = $('#gform_confirmation_wrapper_' + formId);
    let headerOffset = $('header').outerHeight();
    if ($target.length) {
      $('html, body').animate(
        { scrollTop: $target.offset().top - headerOffset - 50 },
        500
      );
      return false;
    }
  });

  /**
   * Hide gravity forms required field message on data input
   */
  $('body').on(
    'change keyup',
    '.gfield input, .gfield textarea, .gfield select',
    function() {
      let $field = $(this).closest('.gfield');
      if ($field.hasClass('gfield_error') && $(this).val().length) {
        $field.find('.validation_message').hide();
      } else if ($field.hasClass('gfield_error') && !$(this).val().length) {
        $field.find('.validation_message').show();
      }
    }
  );

  let buttonUnderline = $('body').find('.button');
  $(buttonUnderline).each(function() {
    $(this).html(function() {
      var text = $(this).text();
      return '<span class="buttonUnderline">' + text + '</span>';
    });
  });

  /**
   * Add `is-active` class to menu-icon button on Responsive menu toggle
   * And remove it on breakpoint change
   */
  $(window)
    .on('toggled.zf.responsiveToggle', function() {
      $('.menu-icon').toggleClass('is-active');
      preventBodyScrolling();
    })
    .on('changed.zf.mediaquery', function() {
      $('.menu-icon').removeClass('is-active');
      $html.removeClass('is-menu-open');
    });

  /**
   * Close responsive menu on orientation change
   */
  $(window).on('orientationchange', function() {
    setTimeout(function() {
      if ($('.menu-icon').hasClass('is-active') && window.innerWidth < 641) {
        $('[data-responsive-toggle="main-menu"]').foundation('toggleMenu');
      }
    }, 200);
  });

  function setActiveLinks() {
    // eslint-disable-next-line no-unused-vars
    var current = location.href.split('#')[1];
    $('.submenu li a').each(function() {
      var $this = $(this);
      if ($this.attr('href').split('#')[1] === current) {
        let headerOffset = $('header').outerHeight();
        $this.parent().addClass('current_page_ancestor');
        let blockTarget = document.getElementById(current);
        $('html, body').animate(
          { scrollTop: $(blockTarget).offset().top - headerOffset },
          0
        );
      }
    });
  }
  setActiveLinks();

  $('a[href*="#"]')
    // Remove links that don't actually link to anything
    .not('[href="#"]')
    .not('[href="#0"]')
    .click(function(e) {
      // On-page links
      if (
        location.pathname.replace(/^\//, '') ==
          this.pathname.replace(/^\//, '') &&
        location.hostname == this.hostname
      ) {
        // Figure out element to scroll to
        setTimeout(function() {
          if (
            $('.menu-icon').hasClass('is-active') &&
            window.innerWidth < 1024
          ) {
            $('[data-responsive-toggle="main-menu"]').foundation('toggleMenu');
          }
        }, 200);
        $('.submenu li').removeClass('current_page_ancestor');
        $(this)
          .parent()
          .addClass('current_page_ancestor');
        var target = $(this.hash);
        target = target.length
          ? target
          : $('[name=' + this.hash.slice(1) + ']');
        // Does a scroll target exist?
        if (target.length) {
          // Only prevent default if animation is actually gonna happen
          e.preventDefault();
          let headerOffset = $('header').outerHeight();
          $('html, body').animate(
            {
              scrollTop: target.offset().top - headerOffset,
            },
            1000
            // function() {
            //   // Callback after animation
            //   // Must change focus!
            //   var $target = $(target);
            //   $target.focus();
            //   if ($target.is(':focus')) {
            //     // Checking if the target was focused
            //     return false;
            //   } else {
            //     $target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
            //     $target.focus(); // Set focus again
            //   }
            // }
          );
        }
      }
    });

  resizeVideo();
  $('header').css({ opacity: 1, transition: 'all 0.5s ease-out' });
});

/**
 * Scripts which runs after all elements load
 */
$(window).on('load', function() {
  // jQuery code goes here

  let $preloader = $('.preloader');
  if ($preloader.length) {
    $preloader.addClass('preloader--hidden');
  }
});

/**
 * Scripts which runs at window resize
 */
$(window).on('resize', function() {
  // jQuery code goes here

  resizeVideo();
});

/**
 * Scripts which runs on scrolling
 */
$(window).on('scroll', function() {
  // jQuery code goes here

  // Parallax background image
  if ($(window).width() > 1024) {
    var scrolledAbout = $(window).scrollTop();
    $('.qoute__wrapper').each(function() {
      var initY = $(this).offset().top,
        height = $(this).height();
      // Check if the element is in the viewport.
      var visible = isInViewport(this);
      if (visible) {
        var diff = scrolledAbout - initY;
        var ratio = Math.round((diff / height) * 100);
        $(this)
          .children('.qoute')
          .css('top', parseInt(-(ratio * 6)) + 'px');
      }
    });
  }

  if (!$html.hasClass('is-menu-open')) {
    if ($(window).scrollTop() > 1) {
      $('.header').addClass('is-stuck');
    }
    if ($(window).scrollTop() < 1) {
      $('.header').removeClass('is-stuck');
    }
  }
});
